"use strict";
exports.daysToWeeks = daysToWeeks;
var _index = require("./constants.js");
function daysToWeeks(days) {
  const weeks = days / _index.daysInWeek;
  const result = Math.trunc(weeks);
  return result === 0 ? 0 : result;
}
